import { render } from "./AccordionItem.vue?vue&type=template&id=5e7001d7&scoped=true"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import "./AccordionItem.vue?vue&type=style&index=0&id=5e7001d7&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7001d7"]])

export default __exports__